module.exports = __webpack_public_path__ + "img/20190530161053378.2f73beb3.png";